import { render, staticRenderFns } from "./DeleteSelectedItemModal.vue?vue&type=template&id=5734fd11&scoped=true"
import script from "./DeleteSelectedItemModal.vue?vue&type=script&lang=js"
export * from "./DeleteSelectedItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5734fd11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5734fd11')) {
      api.createRecord('5734fd11', component.options)
    } else {
      api.reload('5734fd11', component.options)
    }
    module.hot.accept("./DeleteSelectedItemModal.vue?vue&type=template&id=5734fd11&scoped=true", function () {
      api.rerender('5734fd11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/DeleteSelectedItemModal.vue"
export default component.exports